<div class="header">
  <h2 translate>watch.modalSharing.share</h2>
</div>
<!-- CONTENT -->
<div class="content flex-column">
  <div class="gallery">
    <a (click)="copyLink('facebook')" class="gallery-item">
      <figure>
        <img
          src="assets/images/svg/facebook.svg"
          alt="facebook"
          class="social-img" />
        <figcaption translate>watch.modalSharing.facebook</figcaption>
      </figure>
    </a>
    <a (click)="copyLink('twitter')" class="gallery-item">
      <figure>
        <kin-icon
          [color]="'#ffffff'"
          class="social-img twitter"
          size="32"
          name="X_logo" />
        <figcaption translate>watch.modalSharing.twitter</figcaption>
      </figure>
    </a>
    <a (click)="copyLink('email')" class="gallery-item">
      <figure>
        <img src="assets/images/svg/email.svg" alt="email" class="social-img" />
        <figcaption translate>watch.modalSharing.email</figcaption>
      </figure>
    </a>
  </div>

  <div class="col-md-12 position-relative footer">
    <div class="hr-custom"></div>
    <div class="flex-col position-relative">
      <input
        (click)="copyLink('copy')"
        type="text"
        class="form-control input"
        [value]="linkToshare"
        readonly />
      <span class="icon-link link" (click)="copyLink('copy')"></span>
      <app-button
        [name]="
          !copied
            ? ('watch.modalSharing.copy' | translate)
            : ('watch.modalSharing.copied' | translate)
        "
        [classBtn]="!copied ? 'btn-orange btn-196' : 'btn-blue btn-196'"
        (clickBtn)="copyLink('copy')" />
    </div>
  </div>
</div>
